/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Metrics_Summary_Bar_Rate_CpsInputs */



/**
* | output |
* | --- |
* | "Characters Per Second (CPS)" |
*
* @param {Options_Metrics_Summary_Bar_Rate_CpsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_metrics_summary_bar_rate_cps = /** @type {((inputs?: Options_Metrics_Summary_Bar_Rate_CpsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Metrics_Summary_Bar_Rate_CpsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Characters Per Second (CPS)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Characters Per Second (CPS)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Characters Per Second (CPS)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Characters Per Second (CPS)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Characters Per Second (CPS)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Characters Per Second (CPS)")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Characters Per Second (CPS)")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Characters Per Second (CPS)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Characters Per Second (CPS)")
	return /** @type {LocalizedString} */ ("Characters Per Second (CPS)")
});